import { createContext, useContext, useState } from "react";

type Ctx = {
	pageBg: string;
	setPageBg: (bg: string) => void;
};

const PageBgContext = createContext<Ctx>({
	pageBg: "white",
	setPageBg: () => {},
});

export const PageBgProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [pageBg, setPageBg] = useState<string>("white");
	return <PageBgContext.Provider value={{ pageBg, setPageBg }}>{children}</PageBgContext.Provider>;
};

export const usePageBg = () => useContext(PageBgContext);
